import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Card, Container, Form } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { history } from '../..'

import FooterNew from '../components/Footer'
import { ResetPasswordModel } from '../../app/models/User'
import agent from '../../app/api/agent'

function ResetPasswordNew() {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const { t } = useTranslation()

  const Status = {
    Verifying: 'Verifying',
    Success: 'Success',
  }

  const useQuery = new URLSearchParams(useLocation().search)

  const email = useQuery.get('email') as string
  const token = useQuery.get('token') as string

  const [status, setStatus] = useState(Status.Verifying)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    if (password === confirmPassword) {
      const resetModel: ResetPasswordModel = {
        password,
        token,
        email,
      }
      setLoading(true)
      try {
        await agent.Profile.resetPassword(resetModel)
        setStatus(Status.Success)
        setLoading(false)
      } catch (error: any) {
        toast.error(t(error.response.data))
        setLoading(false)
      }
    } else {
      toast.error(t('err_pass_not_matching'))
    }
  }

  const handleLogin = async () => {
    history.push('/login')
  }

  function getBody() {
    switch (status) {
      case Status.Verifying:
        return (
          <Form>
            <Form.Group className="mb-3 card-font-size">
              <Form.Label className="login-p">{t('password')}</Form.Label>
              <Form.Control
                type="password"
                className="card-input-style"
                placeholder="*********"
                value={password}
                onChange={(e: any) => setPassword(e.target.value)}
                required
              />
              <Form.Label className="login-p">
                {t('confirmpassword')}
              </Form.Label>

              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e: any) => setConfirmPassword(e.target.value)}
                className="card-input-style"
                placeholder="*********"
                required
              />
            </Form.Group>
            <div className="d-grid">
              <button
                className="mt-4 card-login-button"
                onClick={handleSubmit}
                disabled={loading}
                type="button"
              >
                {t('reset_password')}
              </button>
            </div>
          </Form>
        )

      case Status.Success:
        return (
          <>
            <div className="d-flex align-center">
              <i
                style={{ fontSize: '60px' }}
                className="fa-regular text-success fa-circle-check pe-3"
              />
              <h4 className="mt-2 fw-bolder text-black font-status-title-size">
                {t('success')}
              </h4>
            </div>
            <p className="reset-account-card">{t('reset_pass_success')}</p>
            <button
              type="button"
              className="resend-verification-button"
              onClick={handleLogin}
            >
              {t('log_in')}
            </button>
          </>
        )
    }
  }

  return (
    <>
      <Container fluid className="card-center card-background newFont">
        <Card
          style={{ width: '700px' }}
          className=" prevent-select card-shadow login-card-size "
        >
          <Card.Header className="bg-white">
            <h1 className="login-card-title">{t('reset_acc_header')}</h1>
          </Card.Header>
          <Card.Body className="card-padding">{getBody()}</Card.Body>
        </Card>
      </Container>

      <FooterNew />
    </>
  )
}
export default observer(ResetPasswordNew)
